import type { HTMLAttributes } from 'react'
import React from 'react'
import { csx, cx } from '@vtex/admin-ui'

export type SectionsListProps = HTMLAttributes<HTMLDivElement>

export const SectionsList = ({
  className = '',
  ...props
}: SectionsListProps) => (
  <div
    className={cx(
      csx({
        '> *': {
          marginBottom: '2.5rem',
        },
        '@tablet': {
          '> *': {
            marginBottom: '3rem',
          },
        },
        '@desktop': {
          '> *': {
            marginBottom: '5rem',
          },
        },
      }),
      className
    )}
    {...props}
  />
)
